import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import T from 'i18n-react';

import cypressIds from 'Components/cypress_ids.json';
import TextLink from 'Components/shared/TextLink/TextLink';
import { useSeenFilter } from 'Components/VehicleList/SeenFilter';
import { useAppliedFiltersCount } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { applyCypressData } from 'Utilities/helpers';
import { VIEWING_FILTER } from 'Utilities/seenVehicles/seenVehicles';

T.setTexts(require('Components/texts.json'));

const ClearAllButton = ({
	className = '',
	onClick,
	shouldDisplayTextButton,
	text = T.translate('vehicleList.filters.clearAll'),
	...props
}) => {
	const appliedFiltersCount = useAppliedFiltersCount();
	const [seenFilter] = useSeenFilter();
	const isButtonDisabled = appliedFiltersCount === 0 && seenFilter === VIEWING_FILTER.ALL;

	return (
		<div className={className}>
			{shouldDisplayTextButton && !isButtonDisabled && (
				<TextLink {...applyCypressData(cypressIds.links.clearFilters)} onClick={onClick} text={text} theme="white" />
			)}
			{!shouldDisplayTextButton && (
				<button
					className={cx('mw-button mw-theme-dark mw-button-secondary mw-list-button')}
					disabled={isButtonDisabled}
					onClick={onClick}
					type="button"
					{...props}
				>
					{text}
				</button>
			)}
		</div>
	);
};

ClearAllButton.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	shouldDisplayTextButton: PropTypes.bool,
	text: PropTypes.string,
};

ClearAllButton.defaultProps = {
	className: '',
	shouldDisplayTextButton: false,
	text: undefined,
};

export default ClearAllButton;
